import {call, put, takeLatest} from 'redux-saga/effects';
import payoutActions from '../actions/payout.actions';
import PayoutApi from '../api/PayoutApi';

function* setPayoutDate(action) {
    yield put(payoutActions.TYPES.GET_PAYOUT_REPORT(action.payload));
}

function* fetchPayoutOptions() {
    try {
        const response = yield call(PayoutApi.getPayoutOptions);
        yield put(payoutActions.getPayoutOptionsSuccess(response));
    } catch (e) {
        yield put(payoutActions.getPayoutOptionsFailed(e));
    }
}

function* fetchPayoutReport(action) {
    try {
        const response = yield call(PayoutApi.getPayoutReport, action.payload);
        yield put(payoutActions.getPayoutReportSuccess(response));
    } catch (e) {
        yield put(payoutActions.getPayoutReportFailed(e));
    }
}

function* payoutSaga() {
    yield takeLatest(payoutActions.TYPES.SET_PAYOUT_DATE, setPayoutDate);
    yield takeLatest(payoutActions.TYPES.GET_PAYOUT_REPORT, fetchPayoutReport);
    yield takeLatest(payoutActions.TYPES.GET_PAYOUT_OPTIONS, fetchPayoutOptions);
}

export default payoutSaga;
